<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="forecast">
                <div class="card-header pb-0">
                    <div class="justify-content-between d-flex">
                      <div class="d-grid gap-2 d-flex">
                        <button 
                            type="button"
                            @click="downloadPdf"
                            :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_pdf ? 'disabled' : '')">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_pdf"></span>
                            <i class="fa fa-download" v-if="!loading_pdf"></i> Download PDF
                        </button>
                        <button 
                            type="button"
                            @click="download"
                            :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            <i class="fa fa-download" v-if="!loading"></i> Download XLSX
                        </button>
                      </div>
                      <argon-badge variant="gradient" color="primary" class="text-xxs align-self-center" v-if="forecast.state">{{ forecast.state }}</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0">
                    <h5>#{{ forecast.name }}</h5>
                    <div class="row mt-3">
                        <div class="col-sm-6">
                            <table class="w-100 text-sm">
                                <tr>
                                    <td class="text-secondary w-30 align-top">Vendor</td>
                                    <td class="text-dark">{{ forecast.partner_name }}</td>
                                </tr>
                                <tr>
                                    <td class="text-secondary align-top">Vendor Code</td>
                                    <td class="text-dark">{{ forecast.partner_code }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="w-100 text-sm">
                                <tr>
                                    <td class="text-secondary w-30 align-top">PO Period</td>
                                    <td class="text-dark">{{ forecast.po_month }} {{ forecast.po_year }}</td>
                                </tr>
                                <tr>
                                    <td class="text-secondary align-top">Forecast Period</td>
                                    <td class="text-dark">
                                      {{ forecast.forecast_start_month }} {{ forecast.forecast_start_year }} - {{ forecast.forecast_end_month }} {{ forecast.forecast_end_year }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-secondary align-top">Revision</td>
                                    <td class="text-dark">{{ forecast.revision }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table table-bordered align-items-center mb-0">
                            <thead class="text-center text-dark">
                                <tr>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7" rowspan="2">#</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7" rowspan="2">Part Code</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7" rowspan="2">Part Name</th>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7" rowspan="2">Project</th>
                                    <template v-for="month,i in forecast.forecast_month_list" :key="i">
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7" colspan="5">{{ month.month }} {{ month.year }}</th>
                                    </template>
                                </tr>
                                <tr>
                                  <template v-for="month,i in forecast.forecast_month_list" :key="i">
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                                        Qty/Day
                                      </th>
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                                        MDFO
                                      </th>
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                                        FC
                                      </th>
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                                        Stock
                                      </th>
                                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                                        Stock Days
                                      </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in forecast.details" :key="line.id" class="text-center">
                                    <td class="text-xs mb-0">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-xs mb-0 text-start">{{ line.product_code }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0 text-start">{{ line.product_name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0 text-start">{{ line.project_name }}</p>
                                    </td>
                                    <template 
                                      v-for="fc,i in line.forecast_monthly"
                                      :key="i">
                                      <td class="text-xs mb-0">
                                        {{ fc.qty_day }}
                                      </td>
                                      <td class="text-xs mb-0">
                                        {{ fc.mdfo }}
                                      </td>
                                      <td class="text-xs mb-0">
                                        {{ fc.fc }}
                                      </td>
                                      <td class="text-xs mb-0">
                                        {{ fc.stock }}
                                      </td>
                                      <td class="text-xs mb-0">
                                        {{ fc.stock_days }}
                                      </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
// import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "forecast-monthly-detail",
  components: {
    ArgonBadge
    // LoadingState
  },
  data() {
    return {
      forecast: null,
      loading: false,
      loading_pdf: false,
    };
  },
  methods: {
    getDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.FORECAST_DETAIL,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.forecast = response.data.data;
          } else {
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
          });
          this.loading = false;
        });
    },
    download () {
      this.loading = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
              res_id: this.$route.params.id,
              template_report: 'bh_sanko_forecast_vendor.sanko_vendor_forecast_xlsx'
          },
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
          if (response.data.response_code === "0000") {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.forecast.name + ".xlsx";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
              });
          });
    },
    downloadPdf () {
      this.loading_pdf = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_forecast_vendor.action_report_forecast_vendor'
          },
          {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
          )
          .then((response) => {
            console.log(response)
          if (response.data.response_code === "0000") {
              const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.forecast.name + ".pdf";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading_pdf = false
          })
          .catch((e) => {
            this.loading_pdf = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
          });
    }
  },
  mounted() {
    this.getDetail()
  }
};
</script>

<style>

</style>